
<ng-container *ngIf="fieldType === 'number'" >
    <p-inputnumber *ngIf="visible" [(ngModel)]="value" mode="decimal" [inputId]="id"
    [style]="{ width: configStyle.width, height: configStyle.height }"
    [useGrouping]="false" [placeholder]="placeHolder"
    (ngModelChange)="onValueChange($event)"/>
</ng-container>
<ng-container *ngIf="fieldType === 'text'" >
    <input  *ngIf="visible"  pInputText [(ngModel)]="value" type="text" [placeholder]="placeHolder"
    [id]="id"
    [style]="{ width: configStyle.width, height: configStyle.height }"
    (ngModelChange)="onValueChange($event)" />
</ng-container>
<ng-container *ngIf="fieldType === 'dropdown'" >
    <p-select *ngIf="visible" [options]="options" [(ngModel)]="value" [checkmark]="false" optionLabel="name" 
    [style]="{ width: configStyle.width, height: configStyle.height }"  
    [showClear]="false" [placeholder]="placeHolder" class="w-full md:w-56" (onChange)="onValueChange($event)" />
</ng-container>